import { ComponentProps } from "react";
import Ribbon from "@components/Ribbon/Ribbon";

export const BACKGROUND_TRANSITION_DELAY = 1000;
const AUTO_SLIDE_INTERVAL = 10000;


export const RIBBON_DEFAULTS: Partial<ComponentProps<typeof Ribbon>> = {
    minTileWidth: 250,
    maxSlidesPerView: 6,
    autoSlideIntervalMs: AUTO_SLIDE_INTERVAL,
}